import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthServicesService {
  private errorData = new Subject<any>();
  private jsonDataURL = 'assets/province.json';


  getProvincesDetails(): Observable<any> {
    return this.http.get(this.jsonDataURL);
  }
  storeData(data: any) {
    this.errorData.next(data);
  }

  getData() {
    return this.errorData.asObservable();
  }

  imagePathArray = [
    { img: '/assets/login-carousel-images/slide-1.png' },
    { img: '/assets/login-carousel-images/slide-2.png' },
    { img: '/assets/login-carousel-images/slide-3.png' },
  ];

  imagePathaArrayEgypt = [
    { img: '/assets/login-carousel-images/ar-slide-1.png' },
    { img: '/assets/login-carousel-images/ar-slide-2.png' },
    { img: '/assets/login-carousel-images/ar-slide-3.png' },
  ];

  phoneNumberCodes = [
    {
      img: ' /assets/icons/flag-united-kingdom.png',
      code: '+44 United Kingdom',
      country_code: 'GB',
    },
    {
      img: '/assets/icons/flag-egypt.png',
      code: '+20 Egypt',
      country_code: 'EG',
    },
    {
      img: '/assets/icons/flag-cameroon.png',
      code: '+20 Cameroon',
      country_code: 'CM',
    },
    {
      img: '/assets/icons/flag-france.png',
      code: '+33 France',
      country_code: 'FR',
    },
    {
      img: '/assets/icons/flag-guinea.png',
      code: '+224 Guinea',
      country_code: 'GN',
    },
    {
      img: '/assets/icons/flag-kenya.png',
      code: '+254 Kenya',
      country_code: 'KE',
    },
    {
      img: '/assets/icons/flag-madagascar.png',
      code: '+261 Madagascar',
      country_code: 'MG',
    },
    {
      img: '/assets/icons/flag-malawi.png',
      code: '+265 Malawi',
      country_code: 'MW',
    },
    {
      img: '/assets/icons/flag-maritius.png',
      code: '+230 Mauritius',
      country_code: 'MU',
    },
    {
      img: '/assets/icons/flag-nigeria.png',
      code: '+230 Nigeria',
      country_code: 'NG',
    },
  ];

  countryCodes = [
    {
      img: ' /assets/icons/flag-united-kingdom.png',
      code: '+44',
      country: 'United Kingdom',
      country_code: 'GB',
    },
    {
      img: '/assets/icons/flag-egypt.png',
      code: '+20',
      country: 'Egypt',
      country_code: 'EG',
    },
    {
      img: '/assets/icons/flag-cameroon.png',
      code: '+20',
      country: 'Cameroon',
    },
    {
      img: '/assets/icons/flag-guinea.png',
      code: '+224',
      country: 'Guinea',
    },
    {
      img: '/assets/icons/flag-ivory-coast.svg',
      code: '+225',
      country: 'Ivory Coast',
    },
    {
      img: '/assets/icons/flag-kenya.png',
      code: '+254',
      country: 'Kenya',
      country_code: 'KE',
    },
    {
      img: '/assets/icons/flag-madagascar.png',
      code: '+261',
      country: 'Madagascar',
    },
    {
      img: '/assets/icons/flag-malawi.png',
      code: '+265',
      country: 'Malawi',
    },
     {
      img: '/assets/icons/flag-nigeria.png',
      code: '+234',
      country: 'Nigeria',
      country_code: 'NG',
    },
     {
      img: '/assets/icons/flag-uganda.png',
      code: '+230',
      country: 'Uganda',
      country_code: 'UG',
    },
  
    {
      img: '/assets/icons/flag-uae.png',
      code: '+971',
      country: 'UAE',
      country_code: 'AE',
    },
    {
      img: '/assets/icons/flag-philippines.png',
      code: '+63',
      country: 'Philippines',
      country_code: 'PH',
    },
    {
      img: '/assets/icons/flag-south-africa.png',
      code: '+230',
      country: 'South Africa',
      country_code: 'ZA',
    },
    {
      img: '/assets/icons/flag-france.png',
      code: '+33',
      country: 'France',
      country_code: 'FR',
    },
    {
      img: '/assets/icons/flag-france.png',
      code: '+30',
      country: 'Greece',
      country_code: 'GR',
    },
      {
      img: '/assets/icons/flag-maritius.png',
      code: '+230',
      country: 'Mauritius',
    },
    {
      img: '/assets/icons/flag-zambia.png',
      code: '+230',
      country: 'Zambia',
    },
   
    {
      img: '/assets/icons/flag-guinea.png',
      code: '+230',
      country: 'Guinea',
    },
    {
      img: '/assets/icons/flag-tanzania.png',
      code: '+230',
      country: 'Tanzania',
    },
   
    {
      img: '/assets/icons/flag-zimbabwe.png',
      code: '+230',
      country: 'Zimbabwe',
    },
  ];

  localData: any;
  constructor(
    private http: HttpClient,
    private store: Store<any>,
    private router: Router
  ) {
    this.store
      .select((state) => state)
      .subscribe((data) => {
        this.localData = data.authReducer;
      });
  }

  login(data: any) {
    return this.http.post<any>(
      `${environment.baseUrl}/businesses/loginotprequest`,
      data
    );
  }

  resendOtp(data: any) {
    return this.http.post<any>(
      `${environment.baseUrl}/businesses/resend_otp`,
      data
    );
  }



  verifyOTP(data: any) {
    return this.http.post<any>(
      `${this.localData?.loginDetails?.url}/businesses/verifyloginotp`,
      data
    );
  }

  getTncprivatePolicy(languageId) {
    return this.http.get<any>(
      `${this.localData?.loginDetails?.url}/users/${this.localData?.otpVerifiedDetails?.id}/term_and_conditions/${languageId}`
    );
  }
  acceptPrivatePolicy() {
    return this.http.patch<any>(
      `${this.localData?.loginDetails?.url}/users/${this.localData?.otpVerifiedDetails?.id}/accept_tnc`,
      {}
    );
  }

  rejectPrivatePolicy() {
    return this.http.patch<any>(
      `${this.localData?.loginDetails?.url}/users/${this.localData?.otpVerifiedDetails?.id}/reject_tnc`,
      {}
    );
  }

  getUserLanguages() {
    return this.http.get<any>(
      `${this.localData?.loginDetails?.url}/users/${this.localData?.otpVerifiedDetails?.id}/get_user_languages`
    );
  }

  fetchAllApiEndpoints() {
    return this.http.get<any>(`${this.localData?.loginDetails?.url}`);
  }

  fetchUserDetails() {
    return this.http.get<any>(
      `${this.localData?.loginDetails?.url}/businesses/users/${this.localData?.otpVerifiedDetails?.id}`
    );
  }

  fetchBusinessDetails(businessID: any) {
    return this.http.get<any>(
      `${this.localData?.loginDetails?.url}/businesses/${businessID}`
    );
  }

  logout() {
    return this.http.post<any>(
      `${this.localData?.loginDetails?.url}/businesses/logout`,
      {}
    );
  }
  isOtpRequested() {
    if (this.localData?.loginDetails?.url) {
      return true;
    } else {
      return false;
    }
  }

  isOtpGenerated() {
    if (Object.keys(this.localData?.loginDetails).length > 0) {
      return true;
    } else {
      return false;
    }
  }
  isLoggedIn() {
    if (this.localData.loginDetails !== '') {
      if (
        this.localData?.otpVerifiedDetails?._user_token &&
        this.localData?.otpVerifiedDetails?.tnc_accepted
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  isTncAccepted() {
    if (this.localData?.otpVerifiedDetails?.tnc_accepted) {
      return true;
    } else {
      return false;
    }
  }

  changeLanguage(lanId: any) {
    let languageId = {
      language_id: lanId,
    };
    return this.http.patch<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.businessDetails?.id}/users/${this.localData?.otpVerifiedDetails?.id}`,
      languageId
    );
  }

  getRegistrationFaq() {
    let queryParams = new HttpParams();
    let locale = localStorage.getItem('userLanguageLocale')
      ? localStorage.getItem('userLanguageLocale')!
      : 'en-KE';
    queryParams = queryParams.append('locale', locale);
    return this.http.get<any>(
      `${environment.baseUrl}/api/v1/registration_faq_qna`,
      { params: queryParams }
    );
  }

  getLoginFaq() {
    let queryParams = new HttpParams();
    let locale = localStorage.getItem('userLanguageLocale')
      ? localStorage.getItem('userLanguageLocale')!
      : 'en-KE';
    queryParams = queryParams.append('locale', locale);
    return this.http.get<any>(`${environment.baseUrl}/api/v1/login_faq_qna`, {
      params: queryParams,
    });
  }

  getCallUSDetails() {
    return this.http.get<any>(`${environment.baseUrl}/api/v1/faq_call_us`);
  }

  postContactUsData(data: any) {
    return this.http.post<any>(`${environment.baseUrl}/login_contact_us`, data);
  }

  verifyRecaptcha(data: any) {
    return this.http.post<any>(
      `${environment.baseUrl}/api/v1/faq_verify_captcha`,
      data
    );
  }



  aiukSignUp(data: any) {
    let formData = new FormData();
    formData.append('first_name', data?.first_name);
    formData.append('last_name', data?.last_name);
    formData.append('middle_name', data?.middle_name);
    formData.append('mobile', data?.mobile);
    formData.append('email', data?.email);
    formData.append('business_name', data?.business_name);
    formData.append('business_address', data?.business_address);
    formData.append('profile_image', data?.profile_image);

    return this.http.post<any>(`${'https://aws-clickit-eu-api-staging.clickitapp.io'}/aiuk_clickit_signup_customers`, formData)
  }

  signUpSubmit(data: any, receive_image: File, receive_imageBIR: File, receive_imageSelf: File) {
    let formData = new FormData();
    formData.append('customer_first_name', data?.customer_first_name);
    formData.append('customer_last_name', data?.customer_last_name);
    formData.append('customer_middle_name', data?.customer_middle_name);
    formData.append('customer_email', data?.customer_email);
    formData.append('customer_mobile', data?.customer_mobile);
    formData.append('business_name', data?.business_name);
    formData.append('business_region', data?.business_region);
    formData.append('business_customer_type', data?.business_customer_type);
    formData.append('business_house_no_n_building', data?.business_house_no_n_building);
    formData.append('business_street', data?.business_street);
    formData.append('business_barangay', data?.business_barangay);
    formData.append('business_zip_code', data?.business_zip_code);
    formData.append('business_tin_no', data?.business_tin_no);
    formData.append('business_email', data?.business_email);
    formData.append('business_phone', data?.business_phone);
    formData.append('business_owner_first_name', data?.business_owner_first_name);
    formData.append('business_owner_last_name', data?.business_owner_last_name);
    formData.append('business_middle_name', data?.business_middle_name);
    formData.append('business_city', data?.business_city);
    formData.append('business_owner_name', 'test');
    formData.append('business_owner_last_name', data?.business_owner_last_name);
    formData.append('shipping_name', data?.shipping_name);
    formData.append('shipping_region', data?.shipping_region);
    formData.append('shipping_city', data?.shipping_city);
    formData.append('shipping_house_no_n_building', data?.shipping_house_no_n_building);
    formData.append('shipping_street', data?.shipping_street);
    formData.append('shipping_barangay', data?.shipping_barangay);
    formData.append('shipping_zip_code', data?.shipping_zip_code);
    formData.append('shipping_contact_person', data?.shipping_contact_person);
    formData.append('shipping_contact_number', data?.shipping_contact_number);
    formData.append('registration_tnc', 'true');
    formData.append('referred_by',data?.referred_by);
    if (receive_image) {
      formData.append('shipping_governament_id_image', receive_image[0]);
    }
    if (receive_imageBIR) {
      formData.append('shipping_bir_image', receive_imageBIR[0]);
    }

    if (receive_imageSelf) {
      formData.append('self_photo_image', receive_imageSelf[0]);
    }


    formData.append('country_id', '16');
    formData.append('status', data?.status);
    return this.http.post<any>(`${environment.baseUrl}/clickit_signup_customers`, formData)

  }
  // aiukSignUp(data:any){
  //   return this.http.post<any>(`${'https://aws-clickit-eu-api-staging.clickitapp.io'}/aiuk_clickit_signup_customers`, data)
  // }
}
